import * as React from 'react';
import { Deal, IAffiliate, IGiftCardLine } from '@poinz/api';
import { getSocialLinks } from './SocialLinks.utils';
import Link from 'components/Link';
import Button from 'components/Button';
import { useTranslation } from 'next-i18next';

interface Props {
  entity: Deal | IGiftCardLine | IAffiliate;
}

const SocialLinks: React.FC<Props> = ({ entity }) => {
  const { t } = useTranslation();
  const socialLinks = getSocialLinks(entity);

  if (!socialLinks?.length) return null;

  return (
    <div className="SocialLinks flex gap-3 flex-wrap">
      {socialLinks.map(({ href, key }) => (
        <Link key={key} href={href} target="_blank">
          <Button variant="tertiary-badge" size="badge">
            {t(key)}
          </Button>
        </Link>
      ))}
    </div>
  );
};

export default SocialLinks;
